import { Navigate, useLocation } from 'react-router-dom';

export function LegacyWhatsAppRedirect({ to }: { to: string }) {
  const { search, hash } = useLocation();
  const [pathname, targetSearch] = to.split('?');
  if (!targetSearch) return <Navigate to={`${to}${search}${hash}`} replace />;
  const params = new URLSearchParams(search);
  for (const [key, value] of new URLSearchParams(targetSearch)) params.set(key, value);
  return <Navigate to={`${pathname}?${params.toString()}${hash}`} replace />;
}
